(function () {
  function initialiseViewer() {
    var dialog = document.querySelector('[data-size-dialog]');
    if (!dialog) return;

    var viewer = dialog.querySelector('[data-size-guide-viewer]');
    var pages = dialog.querySelector('[data-size-guide-pages]');
    var level = dialog.querySelector('[data-size-guide-zoom-level]');
    var zoomIn = dialog.querySelector('[data-size-guide-zoom-in]');
    var zoomOut = dialog.querySelector('[data-size-guide-zoom-out]');
    var reset = dialog.querySelector('[data-size-guide-zoom-reset]');
    if (!viewer || !pages || !level || !zoomIn || !zoomOut || !reset) return;

    var zoom = 1;

    function renderZoom() {
      pages.style.width = Math.round(zoom * 100) + '%';
      level.textContent = Math.round(zoom * 100) + '%';
      zoomOut.disabled = zoom <= 0.75;
      zoomIn.disabled = zoom >= 3;
    }

    zoomIn.addEventListener('click', function () {
      zoom = Math.min(3, zoom + 0.25);
      renderZoom();
    });

    zoomOut.addEventListener('click', function () {
      zoom = Math.max(0.75, zoom - 0.25);
      renderZoom();
    });

    reset.addEventListener('click', function () {
      zoom = 1;
      viewer.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      renderZoom();
    });

    renderZoom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseViewer);
  } else {
    initialiseViewer();
  }
})();
